export default {

    probabilityMeasureTypes: 'Medidas de Probabilidad',
    editProbabilityMeasureTypesError: 'Error al editar las medidas de probabilidad',
    updateProbabilityMeasureTypesSuccess: 'Medidas de probabilidad actualizadas con éxito',
    editLoaderProbabilityMeasureTypes: 'Actualizando medidas de probabilidad...',
    getProbabilityMeasureTypesError: 'Error al obtener las medidas de probabilidad',
    rangeOrderError: 'El rango de orden es incorrecto ',
    probabilityOcurrence: 'Probabilidad de Ocurrencia',
    probabilityMeasureDescription: 'En esta sección puedes definir el valor de la probabilidad de ocurrencia asociado a un riesgo.',
    probabilityMeasureGuide: 'Define los valores de probabilidad de ocurrencia asociados a cada riesgo en esta sección.',


}